'use client';

import { HtmlLangSync } from '@/components/layout/HtmlLangSync';
import { useSyncLocaleCookie } from '@/lib/hooks/util/useLocaleSync';

import type { ReactNode } from 'react';

export const LocaleSyncProvider = ({
  children,
  locale,
}: {
  children: ReactNode;
  locale: string;
}) => {
  useSyncLocaleCookie();
  return (
    <>
      <HtmlLangSync locale={locale} />
      {children}
    </>
  );
};
